<template>
    <Page :header="(!isPWA && !isTgApp) ? header[lang_].title : ''" type="gray">
        <template v-slot:body>
            <Transfers />
        </template> 
    </Page>
</template>
  
<script>
import Connect      from '@/assets/js/Connect'
import Helper       from '@/assets/js/Helper'
import Page         from '@/components/sides/Page.vue' 
import Transfers    from '@/components/personal/transfer/List.vue' 
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            header: {
                en: {title: "My transfers"} ,
                ru: {title: "Мои переводы"} ,
            }, 
        }
    },
    components: {
        Page,
        Transfers
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)

        try {
            this.SetHeaderTitle(this.header[this.lang_].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}
</script>